/* carrusel de banners: flechas, puntos y avance cada 6 s (se para al pasar el ratón, al tocar o con movimiento reducido) */
(function () {
  function montar(bn) {
    if (bn.dataset.goatOn) return;
    bn.dataset.goatOn = '1';
    var t = bn.querySelector('.bn-track'), dots = [].slice.call(bn.querySelectorAll('.bn-dots button')), n = dots.length, timer;
    if (!t || !n) return;
    function cur() { return Math.round(t.scrollLeft / t.clientWidth); }
    function go(i) { i = (i + n) % n; t.scrollTo({ left: i * t.clientWidth }); }
    bn.querySelector('.bn-prev').onclick = function () { go(cur() - 1); };
    bn.querySelector('.bn-next').onclick = function () { go(cur() + 1); };
    dots.forEach(function (d, i) { d.onclick = function () { go(i); }; });
    t.addEventListener('scroll', function () { var c = cur(); dots.forEach(function (d, i) { d.setAttribute('aria-current', i === c ? 'true' : 'false'); }); }, { passive: true });
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || n < 2) return;
    function stop() { clearInterval(timer); }
    function play() { stop(); timer = setInterval(function () { go(cur() + 1); }, 6000); }
    bn.addEventListener('mouseenter', stop); bn.addEventListener('mouseleave', play);
    bn.addEventListener('focusin', stop); bn.addEventListener('touchstart', stop, { passive: true });
    play();
  }
  function todos() { document.querySelectorAll('.bn').forEach(montar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
  document.addEventListener('shopify:section:load', todos);
})();
